module.exports = __webpack_public_path__ + "static/media/cicdecd.6c8b7420.png";